'use strict';

const googleRecaptcha = require('int_google/googleRecaptcha');
const tagmanagerAccount = require('int_analytics/tagmanagerAccount');
const tagmanagerForm = require('int_analytics/tagmanagerForm');
let $formDestination = window.location.href;
let $formSubmitText = '';
var emailOtpBlock = $('.email-otp-block');
var loginForm = $('#checkout-login-form');
var otpForm = $('#checkout-otp-form');
var registerForm = $('#register-form');
var existingCustomerPopupHeader = $('.existing-customerpopup-header');
var registerPopupHeader = $('.registerpopup-header');
var registrationPopup = $('#registration-popup');
var registerPopupLeft = $('.registerpopup-left');
var mobileOtpBlock = $('.mobile-otp-block');
var loginModal = $('#loginModal');
var loginPopupLeft = $('.loginpopup-left');
var otpPopupLeft = $('.otppopup-left');
var alreadyRegisterEmailLeft = $('.already-registeremail-left');
var fullname = $('#full-name');
var phoneNumber = $('#phone-number');
var countryCode = $('#country-code');
var email = $('#email');
var emailRadioText = $('#emailRadioText');
var emailRadioButton = $('#emailRadioButton');
var phoneRadioButton = $('#phoneRadioButton');
var loginPopup = $('#login-popup');

// mobile no.
var timerId;
var timeLeft = 180;
var ele = $('#timer-some-div');
/**
 * Set the colour and font of the resend link
 */
function hideCountDown() {
    ele.css('display', 'none');
    $('#resendLinkOtp').addClass('custom-color');
    $('#some-div').html('').css('opacity', '0');
    $('#resendLink').addClass('custom-color').addClass('cursor-custom').removeAttr('disabled');
}

/**
 * Reverse count down for otp
 */
function countdown() {
    if (timeLeft === -1) {
        clearInterval(timerId);
        if (window.isTimer) {
            window.isTimer = false;
        }
        hideCountDown();
        $('#resendLinkOtp').addClass('cursor-custom').removeAttr('disabled');
    } else {
        if (!window.isTimer) {
            window.isTimer = true;
        }
        var sec = timeLeft;
        var minute = parseInt((sec / 60), 10);
        var second = parseInt(sec - (minute * 60), 10);
        var timer2 = minute + ':' + second;
        ele.html('in ' + timer2 + 's');
        ele.css('display', 'inline-block');
        timeLeft -= 1;
    }
}

/**
 * show error message
 */
function showErrorMessage() {
    // error handling code will be placed here
}

/**
 * disable the fields on register form for new customer
 * @param {string} isdCode isdCode for country
 * @param {string} responseData responseData
 */
function newCustomerDisableFields(isdCode, responseData) {
    phoneNumber.val(responseData.primaryMobile.phoneNumber);
    countryCode.val(isdCode);
    phoneNumber.attr('disabled', true);
    countryCode.attr('disabled', true);
    phoneNumber.addClass('cursor-custom-not-allowed');
}

/**
 * disable the fields on almost form for existing customer
 * @param {string} isdCode isdCode for country
 * @param {string} responseData responseData
 */
function existingCustomerDisableFields(isdCode, responseData) {
    phoneNumber.val(responseData.primaryMobile.phoneNumber);
    countryCode.val(isdCode);
    phoneNumber.attr('disabled', true);
    countryCode.attr('disabled', true);
    phoneNumber.addClass('cursor-custom-not-allowed');
    if (responseData.primaryEmailId !== '' && responseData.primaryEmailId !== null && typeof responseData.primaryEmailId !== 'undefined') {
        email.val(responseData.primaryEmailId);
        email.attr('disabled', true);
        email.addClass('cursor-custom-not-allowed');
    }

    if (responseData.nameDetails && (responseData.nameDetails.firstName !== null || responseData.nameDetails.middleName !== null || responseData.nameDetails.lastName !== null)) {
        var firstName = responseData.nameDetails.firstName !== null ? responseData.nameDetails.firstName : '';
        var middleName = responseData.nameDetails.middleName !== null ? responseData.nameDetails.middleName : '';
        var lastName = responseData.nameDetails.lastName !== null ? responseData.nameDetails.lastName : '';
        var fullName;
        if (middleName) {
            fullName = firstName + ' ' + middleName + ' ' + lastName;
        } else {
            fullName = firstName + ' ' + lastName;
        }
        fullname.val(fullName);
    }
}

$('#countrycodeleft').on('change', function () {
    $('#mobile-guest-user').val('').removeClass('show-error');
    $('#registereduser-left-mobile-error').html('');
    $('#mobile-left').val('');
    $('.registereduser-left-mobileinputfield').css('border', 'black solid 1px');
    $('#default-error').removeClass('d-block');
    $('#valid-error').removeClass('d-block');
    $('.phoneno-field').removeClass('error');
    $('.guestuser-left-requestbtn').attr('toogle', 0);
});

$('.registereduser-left, .registereduser-otp').on('keyup', function (event) {
    if (event.key === 'Enter' && $('.registereduser-left').css('display') === 'block'
        && $('.registereduser-otp').css('display') === 'none') {
        $('.registereduser-left-requestbtn').trigger('click');
    } else if (event.key === 'Enter' && $('.registereduser-otp').css('display') === 'block'
        && ($('.registereduser-left').css('display') === 'none' || $('.registereduser-left').css('display') === undefined)) {
        $('.registereduser-otp-btn').trigger('click');
    }
});

$('.guestuser-left').on('keyup', function (event) {
    if (event.key === 'Enter' && $('.guestuser-left').css('display') === 'block'
        && ($('.registereduser-left').css('display') === 'none' || !$('#pills-register').hasClass('active'))
        && ($('.registereduser-otp').css('display') === 'none' || !$('#pills-register').hasClass('active'))) {
        $('.guestuser-left-requestbtn').trigger('click');
    }
});

$('#resendLinkOtp').on('click', function () {
    $('#registereduser-otp-error').html('');
    $('.otp-input').css('border', 'black solid 1px');
    $.ajax({
        url: $(this).data('resendotpurl'),
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (data.success) {
                if (data.responseData) {
                    timeLeft = 180;
                    clearInterval(timerId);
                    timerId = setInterval(countdown, 1000);
                    $('#resendLinkOtp').removeClass('cursor-custom').removeClass('custom-color').addAttr('disabled');
                    var $form = $('#checkout-otp-form');
                    $form.find("input[type='tel']").each(function () {
                        $('.otp-input').val('');
                    });
                }
            } else if (data.errorMessage) {
                $('.otp-input').css('border', '1px solid red');
                $('#registereduser-otp-error').html(data.errorMessage);
            }
        },
        error: function () { }
    });
});

$('.registereduser-left-requestbtn').click(function () {
    $('#registereduser-otp-error').html('');
    $('.otp-input').css('border', '1px solid #908e8a');
    $('#ssoNameDetailsEmpty').val(false);
    var maxLength = $('#mobile-left').attr('maxlength');
    var minLength = $('#mobile-left').attr('minlength');
    var regexHelper;
    if (minLength) {
        regexHelper = '^[0-9]{' + parseInt(minLength, 10) + ',' + parseInt(maxLength, 10) + '}$';
    } else {
        regexHelper = '^[0-9]{' + parseInt(maxLength, 10) + '}$';
    }
    var regex = new RegExp(regexHelper, 'g');
    var mobile = $('#mobile-left').val();
    var $form = loginForm;
    var ajaxFlag = false;
    var $registerUserLable = $('.registereduser-left-mobileno-label');
    var actionPlaceInCart = $('#registered-user-mob-no-small').data('place') === 'cart' || $('#registered-user-mob-no-small').data('place') === 'checkout';
    if (mobile !== '') {
        if (regex.test(mobile) === false) {
            $('#registereduser-left-mobile-error').html('Enter Valid Mobile Number');
            $('.registereduser-left-mobileinputfield').css('border', 'red solid 1px');
            $registerUserLable.css('color', 'red');
        } else {
            ajaxFlag = true;
            $('.registereduser-left-mobileinputfield').css('border', 'black solid 1px');
        }
    } else {
        $('#registereduser-left-mobile-error').html('Enter Mobile Number!');
        $('.registereduser-left-mobileinputfield').css('border', 'red solid 1px');
        $registerUserLable.css('color', 'red');
    }
    if (ajaxFlag) {
        $.ajax({
            url: $(this).data('sendotp'),
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.success) {
                    $('#timer-some-div').hide();
                    if (actionPlaceInCart) {
                        $('#registered-user-mob-no-small').text($('#registered-user-mob-no-small').data('text'));
                        timeLeft = 180;
                        clearInterval(timerId);
                        timerId = setInterval(countdown, 1000);
                    }
                    $('#checkout-otp-mobile').text($('#registered-user-mob-no').data('maskno') + $('#mobile-left').val().slice(-4));
                    $('#registered-user-mob-no-small').text($('#registered-user-mob-no-small').text().replace('*', $('#registered-user-mob-no-small').data('maskno') + mobile.slice(-4)));
                    $('.registereduser-left').addClass('d-none');
                    $('.registereduser-otp').removeClass('d-none');
                    if (!actionPlaceInCart) {
                        clearInterval(timerId);
                        timerId = setInterval(countdown, 1000);
                    }
                    $('.loginpopup-left').addClass('d-none');
                    $('.otp-input:first').focus();
                    $('#entered-mobile-number').removeClass('pl-2').empty().text($('#registered-user-mob-no').data('maskno') + mobile.slice(-4));
                    otpPopupLeft.removeClass('d-none');
                    if (!$('#some-div .count')[0]) {
                        $('#some-div').append('<span class="count"></span>');
                    }
                    $('#timer-some-div').css('style', 'inline-block');
                } else if (data.accBlocked) {
                    $('.container .toast-error-container').removeClass('hide-error-toast');
                    $('.toast-error-message').html(data.errorMessage);
                } else {
                    $('#registereduser-left-mobile-error').html(data.errorMessage);
                    $('.registereduser-left-mobileinputfield').css('border', '1px solid red');
                }
                $('#checkout-otp-form').trigger('reset');
            }
        });
    }
});

$('.register-user-otp').keyup(function () {
    $('#registereduser-otp-error').html('');
});

$('.registereduser-left-requestbtn').click(function () {
    $(this).attr('togglevalue', 1);
    $('#mobile-left').focus();
});

$('#mobile-left').keyup(function () {
    var maxlength = Number($(this).attr('maxlength'));
    var inputlength = $(this).val().length;
    var $registeredUser = $('.registereduser-left-mobileno-label');
    var minlength = Number($(this).attr('minlength'));
    if (minlength) {
        if (inputlength > minlength - 1) {
            $('#registereduser-left-mobile-error').html('');
            $('.registereduser-left-mobileinputfield').css('border', '1px solid black');
            $registeredUser.css('color', 'black');
        } else {
            $('#mobile-left').css('border', '1px solid red');
            $registeredUser.css('color', 'red');
            if (inputlength === 0) {
                $('#registereduser-left-mobile-error').html('Enter Mobile Number!');
            }
        }
    } else if (inputlength < maxlength) {
        $('#mobile-left').css('border', '1px solid red');
        $registeredUser.css('color', 'red');
        if (inputlength === 0) {
            $('#registereduser-left-mobile-error').html('Enter Mobile Number!');
        }
    } else {
        $('#registereduser-left-mobile-error').html('');
        $('.registereduser-left-mobileinputfield').css('border', '1px solid black');
        $registeredUser.css('color', 'black');
    }
});

$('#mobile-left').keypress(function (e) {
    var charCode = e.which ? e.which : e.keyCode;
    if (String.fromCharCode(charCode).match(/[^0-9]/g)) {
        return false;
    }
    return true;
});
/**
 * Login or signup
 * @param {*} object - this object
 */
function loginOrSignupForCheckout(object) {
    var $form = otpForm;
    $.ajax({
        url: object.data('checkoutverifyotp'),
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
            countdown();
            if (data.success) {
                let $formId = $('#login-popup').data('form-id') || 'Log_n_sign_up';
                let $formName = $('#login-popup').data('form-name') || 'Log in Sign Up';
                $formSubmitText = !!$('.customerLoginScreen .registereduser-otp-btn').text() && $('.customerLoginScreen .registereduser-otp-btn').text().trim();
                tagmanagerAccount.accountLoginSignup('login', 'Organic Login');
                tagmanagerForm.formSubmitHandle($formId, $formName, $formDestination, $formSubmitText);
                var responseData = data.responseData;

                // get the country code from countriesConfig
                var countrySelect = $('select[name="dwfrm_profile_countryCode"]', loginForm);
                var isdCode = $('option[value="' + responseData.primaryMobile.isdCode + '"]', countrySelect).data('isoCode');

                // TODO: dependecy on SSO
                // create global session for the SSO flow
                // if (data.accessToken) {
                //     createtdlSsoAuthSession(data.accessToken);
                // }

                if (data.registerForm === true) {
                    $('#loginModal').modal('show');
                    loginPopup.addClass('d-none');
                    registrationPopup.removeClass('d-none');
                    existingCustomerPopupHeader.addClass('d-none');
                    registerPopupHeader.removeClass('d-none');
                    newCustomerDisableFields(isdCode, responseData);
                } else if (data.updateForm === true) {
                    $('#loginModal').modal('show');
                    loginPopup.addClass('d-none');
                    registrationPopup.removeClass('d-none');
                    registerPopupHeader.addClass('d-none');
                    existingCustomerPopupHeader.removeClass('d-none');
                    existingCustomerDisableFields(isdCode, responseData);
                } else {
                    window.location.assign(object.data('checkouturl'));
                }
            } else {
                $('.registereduser-otp-btn').css({ 'pointer-events': 'auto', 'background': '', 'opacity': ''}).prop('disabled', false); // eslint-disable-line
                $('body').spinner().stop();
                $('#registereduser-otp-error').html(data.errorMessage);
                $('.register-user-otp').css('border', 'red solid 1px');
            }
        }
    });
}

$('body').on('click', '.registereduser-otp-btn', function () {
    var object = $(this);
    var registereduserOtpBtn = $('.registereduser-otp-btn');
    registereduserOtpBtn.prop('disabled', true).css({ 'pointer-events': 'none', 'background': '#631617', 'opacity': 1 }); // eslint-disable-line
    registerPopupLeft.removeClass('d-none');
    alreadyRegisterEmailLeft.addClass('d-none');
    var googleRecaptchav3Enabled = $('#login-google-recaptcha-main').data('google-recaptchav3-enabled');
    if (googleRecaptchav3Enabled) {
        (googleRecaptcha.getRecaptchaResponse()).then((captchaVerified) => {
            if (captchaVerified) {
                loginOrSignupForCheckout(object);
            } else {
                // recaptcha error msg
                $('#checkout-otp-form #recaptcha-validation-failed').html($('#recaptcha-block').data('error-msg'));
            }
        });
    } else {
        loginOrSignupForCheckout(object);
    }
    $('.registereduser-otp-btn').css({ 'pointer-events': 'auto', 'background': '', 'opacity': ''}).prop('disabled', false); // eslint-disable-line
});

$('.loginpopup-close').click(function () {
    loginModal.modal('hide');
});

$('.registerpopup-close').click(function () {
    $('#registerModal').modal('hide');
});

$('.emailid-already-submitbutton').on('click', function () {
    // clear otp field
    otpForm.trigger('reset');

    if (emailRadioButton.is(':checked')) {
        var emailswappableurl = new URL($(this).data('emailswappableurl'));
        emailswappableurl.searchParams.append('email', emailRadioText.text());

        $.ajax({
            url: emailswappableurl,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    if (data.responseData) {
                        var resData = JSON.parse(data.responseData);
                        loginPopup.removeClass('d-none');
                        registrationPopup.addClass('d-none');
                        mobileOtpBlock.addClass('d-none');
                        emailOtpBlock.removeClass('d-none');
                        $('#isEmailSelected').val(true);
                        $('.otppopup-submitbutton')[0].setAttribute('data-refid', resData.refId);
                        timeLeft = 59;
                        timerId = setInterval(countdown, 1000);
                    }
                } else {
                    showErrorMessage();
                }
            },
            error: function () { }
        });
    } else if (phoneRadioButton.is(':checked')) {
        loginPopup.removeClass('d-none');
        registrationPopup.addClass('d-none');
        loginPopupLeft.removeClass('d-none');
        otpPopupLeft.addClass('d-none');
        registerPopupLeft.removeClass('d-none');
        alreadyRegisterEmailLeft.addClass('d-none');

        // clear form data
        loginForm.trigger('reset');
        registerForm.trigger('reset');
        otpForm.trigger('reset');

        phoneRadioButton.prop('checked', false);
    }
});

// Timer
/**
 * Set the otp boxes
 */

$('body').on('keyup', '.otp-input', function () {
    if ($(this).val().length.toString() === $(this).attr('maxlength')) {
        $(this).next('.otp-input').focus();
    }
});

$('#mobile-left').on('focusout', function () {
    var minlength = $(this).attr('minlength');
    var inputlength = $(this).val().length;
    if (inputlength === 0) {
        $('.registereduser-left-mobileno-label').css('color', 'black');
        $('#registereduser-left-mobile-error').html($('#blackMobileNumberError').val());
    } else if (inputlength < minlength) {
        $('.registereduser-left-mobileno-label').css('color', 'red');
        $('#registereduser-left-mobile-error').html($('#mobileNumberError').val());
    }
});
